var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"crowded"}},[_c('div',{staticClass:"crowded-box"},[_c('img',{attrs:{"src":require("@/assets/img/YonghuiSync/stock.png")}}),_c('h1',[_vm._v("系统繁忙")]),_c('div',[_vm._v(" 活动太火爆啦，建议2个工作日后再试，感谢您的谅解。 ")])])])
}]

export { render, staticRenderFns }